import { computed, Injectable, signal } from '@angular/core';

/**
 * Tracks in-flight HTTP requests for a global loading UI.
 * {@link HttpLoadingInterceptor} increments/decrements the counter.
 */
@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  private readonly pending = signal(0);

  /** True while at least one HTTP request is active (unless skipped via context). */
  readonly isLoading = computed(() => this.pending() > 0);

  begin(): void {
    this.pending.update((n) => n + 1);
  }

  end(): void {
    this.pending.update((n) => Math.max(0, n - 1));
  }
}
